module.exports = __webpack_public_path__ + "static/media/mr-godzilla.37f6026b.png";